import { jsx as e } from "react/jsx-runtime";
import { Close as t } from "@videoblocks/react-icons";
//#region src/components/atoms/Badge/BadgeButton.tsx
function n({ size: n, onClick: r }) {
	return /* @__PURE__ */ e("button", {
		style: n === "small" ? {
			width: "6px",
			height: "6px"
		} : {
			width: "8px",
			height: "8px"
		},
		onClick: r,
		children: /* @__PURE__ */ e(t, { className: "block fill-current" })
	});
}
//#endregion
export { n as BadgeButton };
